const Cookies = {
    /**
     * Retrieves the cookie value by cookie name.
     *
     * @param {String} name
     * @return {String}
     */
    get: name => {
        const regexp = new RegExp(`^${name}=(.*)`, 'i');

        const cookies = decodeURIComponent(document.cookie)
            .split(';')
            .map(cookie => cookie.trim());

        const cookie = cookies.find(wholeCookie => regexp.test(wholeCookie));

        if (cookie) {
            return cookie.match(regexp)[1];
        }

        return '';
    },
};

export default Cookies;



// WEBPACK FOOTER //
// ./src/lib/cookies.js